export default "__VITE_ASSET__ccc347a2__"